import React, { useState } from "react";
import Draggable from "react-draggable";
import { Modal, Row, Col, Button, Typography, Form } from "antd";
import { useDispatch } from "react-redux";
import { InputItem } from "../../../components/forms/FormItems";
import {
  loadProspectuseslines,
  createNewProspectusFromLine,
} from "../prospectusSlice";
import { useSelector } from "react-redux";
import FormActions from "../../../components/forms/FormActions";
import { useIntl } from "react-intl";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { CloseOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import jsPDF from "jspdf";
import {
  getItems,
  getColumns,
  setHeader,
  setBottomContent,
} from "../../../components/print/printSections/prospectus";
import { getProspectusDoc } from "../../../components/util/helpers";
const { Title } = Typography;

const CreateProspectusFromLineForm = (props) => {
  const { hide, visible, prospectusLine } = props;
  const dispatch = useDispatch();
  const intl = useIntl();
  const [form] = Form.useForm();
  const loading = useSelector(
    (state) => state.pendingActions["prospectus/createProspectusFromLine"]
  );
  const organization = useSelector((state) => state.organization.details);

  const [disabled, setDisabled] = useState(true);

  const onFinish = async (values) => {
    const action = await dispatch(
      createNewProspectusFromLine({
        lineId: prospectusLine.id,
        prospectusId: prospectusLine.prospectus_id,
        branchId: prospectusLine.order.patient.branch,
        params: { units: values.units },
      })
    );
    const prospectus = action.payload;
    let doc = new jsPDF({ orientation: "l" });
    const pdf = getProspectusDoc(
      prospectus.lines,
      prospectus,
      doc,
      organization,
      getItems,
      getColumns,
      intl,
      setHeader,
      setBottomContent
    );
    window.open(pdf.output("bloburl"), "_blank");
    if (!action.error) {
      dispatch(loadProspectuseslines());
      form.resetFields();
      hide();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    form.resetFields();
    hide();
  };
  const layout = {
    labelCol: { span: 6, offset: 3 },
    wrapperCol: { span: 5, offset: 1 },
  };

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };
  return (
    <Modal
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      destroyOnClose={true}
    >
      <div>
        <div
          className="header"
          style={{ height: "40px" }}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
          onFocus={() => {}}
          onBlur={() => {}}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onDecline}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0 ",
            textAlign: "center",
          }}
        >
          <FormattedMessage
            id={`app.forms.prospectuses.create_prospectus_from_line_title`}
          />
        </Title>
        <Form
          {...layout}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          style={{
            padding: "0 128px 0px 128px",
            width: "850px",
          }}
        >
          <ChildrenAnimationWrapper>
            <Row>
              <Col span={24} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper key={1} itemKey={1}>
                  <InputItem
                    name={"units"}
                    category="prospectuses"
                    required={true}
                    number={true}
                    twoDigitsNumbers={true}
                    min={0.25}
                    max={prospectusLine?.charged_units}
                    autoFocus={true}
                  />
                </AnimationChildWrapper>
              </Col>
              <Row style={{ width: "100%" }}>
                <Col span={24}>
                  <FormActions
                    resource="accounting"
                    action="editor"
                    onCancel={onDecline}
                    hideDelete={true}
                    hideDecline={true}
                    saveLoading={loading}
                  />
                </Col>
              </Row>
            </Row>
          </ChildrenAnimationWrapper>
        </Form>
      </div>
    </Modal>
  );
};

export default CreateProspectusFromLineForm;
